export default __webpack_public_path__ + "static/media/straw_hat.4cb618e3.png";